import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import ShareIcon from '../../../../assets/tree/share.svg';
import ShareTreeModal from './ShareTreeModal';

const TreeShareButton = ({ dependent }) => {
  const [showShareModal, setShowShareModal] = useState(false);

  return (
    <React.Fragment>
      <Box className="tree-share-btn-wrapper">
        <Box
          className="btn-box share-btn"
          onClick={() => setShowShareModal(true)}
        >
          <Box component="img" className="share-btn-icon" src={ShareIcon} />
          <Box className="share-text-box">
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Share my TaleTree
            </Typography>
          </Box>
        </Box>
      </Box>
      {showShareModal && (
        <ShareTreeModal
          showShareModal={showShareModal}
          setShowShareModal={setShowShareModal}
          username={dependent?.username}
        />
      )}
    </React.Fragment>
  );
};

export default TreeShareButton;
